/**
 * resolveFormDeriveNumericOperand
 *
 * The strict operand coercion for algebraic derives — the derive engine's one
 * deliberate divergence from table formulas. Rule in a line: blank means zero,
 * garbage means no answer. `{ok:false}` makes the whole entry yield `null`.
 *
 * Why not `toNumeric`: it maps `"abc"` to `0`, which is tolerable in a grid cell
 * the user can see and correct, and NOT tolerable in a locked form field where a
 * silent `0` is an uncorrectable wrong number inside a quote total. The derive
 * engine never calls `toNumeric` on an operand. A stored non-finite number is
 * corrupt, not blank, so it is garbage rather than zero. Total; never throws.
 */

export type FormDeriveNumericOperand = { ok: true; value: number } | { ok: false };

function resolveFormDeriveNumericOperand(raw: unknown): FormDeriveNumericOperand {
  if (typeof raw === 'number') {
    return Number.isFinite(raw) ? { ok: true, value: raw } : { ok: false };
  }
  if (raw === null || raw === undefined) return { ok: true, value: 0 };
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed === '') return { ok: true, value: 0 };
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? { ok: true, value: parsed } : { ok: false };
  }
  return { ok: false };
}

export { resolveFormDeriveNumericOperand };
